import React from 'react';
import Table from './../../../components/table';
import { FormattedMessage } from 'react-intl';
import messages from '../../../text/messages';
import { getFullName, getAddress } from '../../../utilities/string';
import { dateToFloatingString } from '../../../utilities/dateTime';
import { getProjectsRateLabelAndValue } from '../../../utilities/rate';

class GeneralTab extends React.Component {
    getRow(message, value) {
        // const urlValue = beginsWith(value, 'http') ? `<a href="${value}">value</a>` : value;

        return {
            label: <FormattedMessage {...message} />,
            value
        };
    }

    getSectionRow(message, value) {
        const row = this.getRow(message, value);
        return {
            label: <div className="topOffset15">{row.label}</div>,
            value: <div className="topOffset15">{row.value}</div>
        };
    }

    render() {
        const { job, position, approvalType, projects } = this.props;
        const { start_date, end_date, user, contractor, contractor_address } = job;
        const { result, reason } = approvalType;

        let contractPeriod = <span>{`${dateToFloatingString(start_date)} - ${end_date ? dateToFloatingString(end_date) : ' '}*`}</span>;

        let workLocation =
            position.work_location_type === 'offsite' ? (
                <FormattedMessage {...messages.workLocationAtWorkerLocation} />
            ) : (
                getAddress(position.work_location_address)
            );

        let workerPref = job.classify_client_pref === 'w2-only' ? 'NA' : job.classify_worker_pref;

        let tableData = {
            columns: [
                { valueMap: d => <span className="row-label">{d.label}</span>, size: 'col-xs-12 col-md-3' },
                { valueMap: d => <span className="row-value">{d.value}</span>, size: 'col-xs-12 col-md-9' }
            ],
            data: [
                this.getRow(messages.name, getFullName(job.user)),
                this.getRow(messages.email, user.email),
                this.getRow(messages.gender, user.gender),
                this.getRow(messages.address, getAddress(contractor_address)),
                this.getRow(messages.typeOfBusiness, contractor.business_type),
                this.getRow(messages.dba, contractor.name),
                this.getRow(messages.linkedIn, user.linkedin_url || '-'),
                this.getRow(messages.businessURL, contractor.web_site || '-'),

                this.getSectionRow(messages.title, job.title),
                this.getRow(messages.positionDescription, job.description),
                this.getRow(messages.contractPeriod, contractPeriod),
                this.getRow(messages.workLocation, workLocation),

                this.getRow(messages.paymentType, <FormattedMessage {...(job.pay_type === 'h' ? messages.hourly : messages.perProject)} />),
                getProjectsRateLabelAndValue(job, projects),

                this.getRow(messages.hoursPerWeek, job.hours_per_week),
                this.getRow(messages.reportingTo, getFullName(position.hiring_manager)),
                this.getSectionRow(messages.clientClassificationPreference, <span>{job.classify_client_pref}</span>),
                this.getRow(messages.workerClassificationPreference, <span className="uppercase">{workerPref}</span>),
                this.getRow(
                    messages.proposedClassification,
                    <React.Fragment>
                        <strong style={{ textTransform: 'uppercase', marginRight: '2px' }}>{result ? result : ''}</strong>
                        <span>{result ? ' - ' : ''}</span>
                        <span>{reason}</span>
                    </React.Fragment>
                )
            ]
        };

        return <Table {...tableData} rowStyle={'onboarding-table-row'} />;
    }
}

export default GeneralTab;



// WEBPACK FOOTER //
// ./src/pages/approval/tabs/general.jsx